import React from "react";
import css from "./index.module.scss";
import { useTranslation } from "react-i18next";
import { animated, useInView } from "@react-spring/web";

const dataList = [
  {
    title: "$singlee_it2",
    title2: "$singlee_it3",
    desc: "$singlee_it4",
  },
  {
    title: "$singlee_it5",
    title2: "$singlee_it6",
    desc: "$singlee_it7",
  },
];

function Index() {
  const { t } = useTranslation();

  const [firstRef, firstRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateX(-100%)",
      },
      to: {
        opacity: 1,
        transform: "translateX(0%)",
      },
    }),
    { threshold: 0.4, once: true }
  );
  const [secondRef, secondRefStyle] = useInView(
    () => ({
      from: {
        opacity: 0,
        transform: "translateY(100%)",
      },
      to: {
        opacity: 1,
        transform: "translateY(0%)",
      },
    }),
    { threshold: 0.2, once: true }
  );

  return (
    <div className={css.contain}>
      <div className={css.first} ref={firstRef}>
        <animated.div className={css.inner} style={firstRefStyle}>
          <div className={css.title}>{t("信息技术服务外包（ITO）")}</div>
          <div className={css.eng}>Information Technology Outsourcing</div>
          <div className={css.desc}>{t("$singlee_it1")}</div>
        </animated.div>
      </div>

      <div className={css.second} ref={secondRef}>
        <div className={css.maintitle}>{t("亮点")}</div>
        <animated.div className={css.inner} style={secondRefStyle}>
          {dataList.map((item, index) => (
            <div className={css.item} key={index}>
              <div className={css.left}>
                <div className={css.icon}>{"0" + (index + 1)}</div>
              </div>
              <div className={css.right}>
                <div className={css.title}>
                  <div>{t(item.title)}</div>
                  <div>{t(item.title2)}</div>
                </div>
                <div className={css.desc}>{t(item.desc)}</div>
              </div>
            </div>
          ))}
        </animated.div>
      </div>
    </div>
  );
}

export default React.memo(Index);
